export const nonDisplayableGroupNames = ['COMPANY_ADMIN', 'COMPANY_OWNER', 'DEVELOPER', 'AGENT'];
export const preferredFallbackCodecsInOrder = 'vp9, vp8, h264';
export const CALL_LOG_PAGE_SIZE = 100;
export const CALL_LOG_DEBOUNCE_TIME_MS = 1_000; // 1 second
export const UPDATE_AVAILABILITY_PROMPT_TIME_MS = 60_0000; // 10 minutes
